import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { RadioField } from 'Common/SemanticWrapper';
import { VendorElectronicFileTypesEnum as FileTypes } from 'Common/Constants/Enumeration/VendorElectronicFileTypesEnum';

class EleConfigFileTypeContainer extends Component {
  onChange = fileType => {
    this.props.input.onChange(fileType);
  };
  render() {
    return (
      <Grid>
        <Grid.Row columns={5}>
          <Grid.Column>
            <Field
              component={RadioField}
              label={'Fixed Length'}
              name="EleConfigFileType"
              value={FileTypes.FixedLength}
              checked={this.props.input.value === FileTypes.FixedLength}
              onChange={() => this.onChange(FileTypes.FixedLength)}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={RadioField}
              label={'CSV'}
              name="EleConfigFileType"
              value={FileTypes.CSV}
              checked={this.props.input.value === FileTypes.CSV}
              onChange={() => this.onChange(FileTypes.CSV)}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={RadioField}
              label={'XML'}
              name="EleConfigFileType"
              value={FileTypes.XML}
              checked={this.props.input.value === FileTypes.XML}
              onChange={() => this.onChange(FileTypes.XML)}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={RadioField}
              label={'US Food'}
              name="EleConfigFileType"
              value={FileTypes.USFOOD}
              checked={this.props.input.value === FileTypes.USFOOD}
              onChange={() => this.onChange(FileTypes.USFOOD)}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={RadioField}
              label={'Sysco'}
              name="EleConfigFileType"
              value={FileTypes.SYSCO}
              checked={this.props.input.value === FileTypes.SYSCO}
              onChange={() => this.onChange(FileTypes.SYSCO)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export const EleConfigFileType = connect(null)(EleConfigFileTypeContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/EleConfigFileType.js